import { render, staticRenderFns } from "./buses.vue?vue&type=template&id=9843a4be"
import script from "./buses.vue?vue&type=script&lang=js"
export * from "./buses.vue?vue&type=script&lang=js"
import style0 from "./buses.vue?vue&type=style&index=0&id=9843a4be&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports